module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/axios@0.21.4_debug@4.4.3_supports-color@5.5.0_/~/axios/index.js
// module id = cRLo
// module chunks = 5